onComplete(function () {
	// Add code here.
});

onComplete(function () {
	// Videoheader Geluid Toggle
	const presetDiv = document.querySelector('.over-ons-header');
	const videoDiv = document.querySelector('.over-ons-header div[data-partial="youtube"]');
	const videoVid = document.querySelector('.over-ons-header div[data-partial="youtube"] video');

	if (!presetDiv || !videoDiv || !videoVid) return;

	let soundIconDiv = null;
	let soundTextDiv = null;
	let clickHandler = null;

	function setup () {
		if (presetDiv.classList.contains('sound-toggle')) return;

		presetDiv.classList.add('sound-toggle');
		presetDiv.classList.add('muted');

		soundIconDiv = document.createElement('div');
		soundIconDiv.classList.add('sound-icon', 'position-absolute');
		videoDiv.appendChild(soundIconDiv);

		soundTextDiv = document.createElement('div');
		soundTextDiv.classList.add('sound-text', 'position-absolute');
		const lang = document.documentElement.lang || '';
		// Support English and a default (NL) language.
		soundTextDiv.textContent = lang.toLowerCase().startsWith('en')
			? "Listen to our story!"
			: "Luister naar ons verhaal!";
		presetDiv.appendChild(soundTextDiv);

		videoVid.setAttribute('autoplay', 'true');
		videoVid.setAttribute('loop', 'true');

		clickHandler = () => {
			if (presetDiv.classList.contains('muted')) {
				videoVid.muted = false;
				presetDiv.classList.remove('muted');
			} else {
				videoVid.muted = true;
				presetDiv.classList.add('muted');
			}
		};
		presetDiv.addEventListener('click', clickHandler);
	}

	function teardown () {
		if (!presetDiv.classList.contains('sound-toggle')) return;

		if (clickHandler) {
			presetDiv.removeEventListener('click', clickHandler);
			clickHandler = null;
		}

		presetDiv.classList.remove('sound-toggle');
		presetDiv.classList.remove('muted');

		if (soundIconDiv) {
			soundIconDiv.remove();
			soundIconDiv = null;
		}
		if (soundTextDiv) {
			soundTextDiv.remove();
			soundTextDiv = null;
		}

		videoVid.removeAttribute('autoplay');
		videoVid.removeAttribute('loop');
		videoVid.muted = true;
	}

	function apply () {
		if (document.body.dataset.editorMode === 'content') {
			teardown();
		} else {
			setup();
		}
	}

	apply();

	new MutationObserver(apply).observe(document.body, {
		attributes: true,
		attributeFilter: ['data-editor-mode'],
	});

});